<template>
    <div class="p-4">
        <ui-form-section class="mb-4" :title="editMode ? item.date : null">
            <ui-date-picker label="Date" name="date" :error="form.errors.get('date')" v-model="form.date" placeholder="Date of the log..." class="xl:col-span-6"></ui-date-picker>
            <ui-input label="Mileage / Hours" name="mileage" :error="form.errors.get('mileage')" v-model="form.mileage" class="xl:col-span-6"></ui-input>
            <ui-radio label="Type" name="type" v-model="form.type" :options="logTypes" :error="form.errors.get('type')" class="xl:col-start-1 xl:col-end-7"></ui-radio>
            <ui-input v-if="form.type === 'Other'" label="Other Type" name="type_other" :error="form.errors.get('type_other')" v-model="form.type_other" class="xl:col-span-6"></ui-input>
            <ui-textarea autoresize label="Notes" name="notes" :error="form.errors.get('notes')" v-model="form.notes"></ui-textarea>

            <ui-select-searchable
                label="Carried Out By"
                v-model="form.carried_out_by"
                :error="form.errors.get('carried_out_by')"
                :search="searchSuppliers"
            ></ui-select-searchable>

            <ui-input-file multiple preview :current="null" label="Add Files" name="files" :error="form.errors.get('files')" v-model="form.files"></ui-input-file>
        </ui-form-section>
        <div class="flex justify-end space-x-4">
            <ui-button-new @click="close">Cancel</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy" v-text="editMode ? 'Save' : 'Create'"></ui-button-new>
        </div>
    </div>
</template>

<script>
import { VehicleLog, Supplier } from '@models'

export default {
    props: {
        vehicle: Object,
        item: Object,
        addItem: Function,
        close: Function,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {}

        return {
            logTypes: [...VehicleLog.SupportedTypes, 'Other'].map(
                value => ({ value, label: value })
            ),
            form: new Form(initialData, async (form) => {
                if (this.editMode) {
                    await this.item.update(this.vehicle.id, form.export())
                    this.close()
                } else {
                    const log = await VehicleLog.create(this.vehicle.id, form.export())
                    this.addItem(log,0)

                    form.reset()
                    this.close()
                }
            }),
        }
    },
    methods: {
        async searchSuppliers (query) {
            return (await Supplier.search(query)).map(x => x.toDropdown())
        },
    },
    computed: {
        editMode () {
            return !! this.item
        },
    },
}
</script>
